export interface SharedFolderBy {
    id?: number;
    first_name?: string;
    last_name?: string;
    profile_image?: string | null;
}

// to single object maping
export const mapSharedFolderBy = (data: any): SharedFolderBy => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    const res: SharedFolderBy = {
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        profile_image: data.profile_image,
    }
    return res;
}

// maping list objects
export const mapSharedFolderBys = (data: any[]): SharedFolderBy[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapSharedFolderBy);
}
